import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveHeaderBreadcrumb } from '@/lib/navigation/resolveHeaderBreadcrumb';

/** Parent section for sub-pages (works with BrowserRouter + useRoutes). */
export function useHeaderBreadcrumb(): { parentLabelKey: string | null; parentTo: string | null } {
  const { pathname } = useLocation();

  return useMemo(() => resolveHeaderBreadcrumb(pathname), [pathname]);
}
